/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

import { DESIGNER_EVENTS } from '../../../app/constants/designer_events';
import { COMPONENT_TYPES } from '../../../app/constants/component_types';

xplenty.directive('componentsList', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/components-list.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        '$rootScope',
        'modalService',

        function ($scope, $rootScope, modalService) {
          $scope.sources = _.filter(COMPONENT_TYPES, function (component) {
            return component.type === 'source';
          });
          $scope.transformations = _.filter(COMPONENT_TYPES, function (component) {
            return component.type === 'transformation';
          });
          $scope.destinations = _.filter(COMPONENT_TYPES, function (component) {
            return component.type === 'destination';
          });
          $scope.workflows = _.filter(COMPONENT_TYPES, function (component) {
            return component.type === 'workflow';
          });

          $scope.getAbs = $rootScope.getAbsoluteUrl;

          $scope.addComponentFromList = function (component) {
            component = angular.copy(component);

            if ($scope.sourceComponentId) {
              component.sourceComponentId = $scope.sourceComponentId;
            }

            $rootScope.$broadcast(DESIGNER_EVENTS.COMPONENT_ADD, component);

            modalService.hideModal();
          };
        },
      ],
    };
  },
]);
